// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".company[data-v-1b35652c]{margin-bottom:7rem}.company .container[data-v-1b35652c]{padding-top:3rem;padding-bottom:3rem}.company .container .company-post[data-v-1b35652c]{border-top:2px solid var(--lightgrey-price-box)}.company .container .company-post[data-v-1b35652c]:last-of-type{border-bottom:2px solid var(--lightgrey-price-box)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
